module.exports = __webpack_public_path__ + "static/media/love-pet.353b2edc.png";